module.exports = __webpack_public_path__ + "img/stats-national-trainer-header.90f4ee75.jpg";